var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":_vm.link,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.text)+"のマニュアル")]),_c('span',{staticClass:"link-icon"},[_c('font-awesome-icon',{attrs:{"icon":"external-link-alt","size":"2x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }